var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.items,"value":_vm.preference,"background-color":_vm.backgroundColor,"label":"Select your Preference"},on:{"change":_vm.changePreference}})}
var staticRenderFns = []

export { render, staticRenderFns }